import { LevelCategory } from './types';

export const POINTS_FOR_TILE_FINALIZATION = 3;
export const CATEGORIES: LevelCategory[] = [
  LevelCategory.Tutorial, LevelCategory.Easy, LevelCategory.Medium, LevelCategory.Hard,
];